<template>
  <base-dialog
    v-model="dialog"
    class="dialog"
    @close="close"
  >
    <template v-slot:title>{{ $t('dialog.buy.title') }}</template>
    <template v-slot:content>
      <div v-if="!finalizedCommand">
        <div v-if="item.customFields && item.customFields.length > 0" class="mt-5">
          <v-form v-model="customForm" ref="customFormRef">
            <input-group
              :label="$t('dialog.buy.inputs')"
              class="rounded-lg"
            >
              <kicklet-text-field
                v-for="(field, index) in item.customFields" :key="index"
                v-model="customFields[field]"
                :label="field"
                :rules="[required(customFields[field]), length(customFields[field], { min: 1, max: 300 })]"
              />
            </input-group>
          </v-form>
        </div>
      </div>
      <div v-else>
        <span>{{$t('shop.copy-and-use-command')}}</span>
        <copy-text-field :input="fullCommand" label="Command"></copy-text-field>
      </div>
    </template>
    <template v-slot:actions>
      <kicklet-button :text="item.customFields && finalizedCommand ? $t('back') : $t('dialog.abort')" color="secondary" @click="abort"/>
      <kicklet-button v-if="!finalizedCommand" class="float-end" :text="$t('dialog.buy.button')" color="primary" @click="buy"/>
    </template>
  </base-dialog>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import BaseDialog from '@/components/dialog/BaseDialog';
import KickletButton from '@/components/custom/kicklet/KickletButton.vue';
import KickletTextField from '@/components/custom/kicklet/KickletTextField.vue';
import InputGroup from '@/components/InputGroup.vue';
import { required, length } from '@/modules/validation';
import { Backend } from '@/services/Backend';
import CopyTextField from '@/components/custom/CopyTextField.vue';

const emit = defineEmits(['update:modelValue', 'abort']);

const props = defineProps({
  modelValue: Object,
  item: Object,
  command: String,
});

const dialog = computed({
  get: () => props.modelValue.display,
  set: (val) => {
    emit('update:modelValue', {
      ...props.modelValue,
      error: null,
      display: val,
    });
  },
});

const customForm = ref(false);
const customFormRef = ref(null);
const customFields = ref({});
const finalizedCommand = ref(false);
const session = ref(null);

const fullCommand = computed(() => {
  let out = `!${props.command} buy ${props.item.command ?? props.item.id}`;
  if (session.value) {
    out += ' ' + session.value;
  }
  return out;
});

function close () {
  customFields.value = {};
  finalizedCommand.value = false;
}

const abort = () => {
  if (finalizedCommand.value && props.item.customFields) {
    finalizedCommand.value = false;
  } else {
    customFields.value = {};
    dialog.value = false;
    emit('abort');
  }
};

const buy = () => {
  customFormRef.value.validate();
  if (!customForm.value) return;

  Backend.createShopSession(props.item.id, customFields.value)
    .then(resp => {
      session.value = resp.data.hash;
      finalizedCommand.value = true;
    })
    .catch(Backend.handleError);
};

onMounted(() => {
  if (!props.item.customFields) {
    finalizedCommand.value = true;
  }
});
</script>

<style scoped>
.dialog {
  max-width: 500px;
}
</style>
